import services from '../services'
import * as types from './mutation-types'

export const getAll = async ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_HOTEL_CATEGORIES, res.data)
    return res.data
  })
)

export const getCategory = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_HOTEL_CATEGORY, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.saveCategory(obj).then(res => {
    commit(types.SET_HOTEL_CATEGORY, res.data.data)
    return res
  })
}

export const deleteCategory = async ({ commit }, id) => {
  await services.delCategory(id).then(res => {
    return res
  })
}
